export enum ContentLibraryEvents {
  ON_DRAG_START = 'on-drag-start',
  ON_DRAG_END = 'on-drag-end',
}

export const CONTENT_LIBRARY = 'content-library'
export const TEMPLATES = 'templates'

export enum ContentLibraryCategoryEnum {
  custom = 'custom',
  featured = 'featured',
}
